import { render, staticRenderFns } from "./ActivityMallLog.vue?vue&type=template&id=f9ba9b46&scoped=true&"
import script from "./ActivityMallLog.vue?vue&type=script&lang=js&"
export * from "./ActivityMallLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ba9b46",
  null
  
)

export default component.exports